import "../../App.scss";
import  "../../assets/css/libraries.css";
import  "../../assets/css/style.css";
import {Helmet} from "react-helmet";


const UnderConstruction = ({ type,setSearchText }) => {


return (
  <div className="row">
        {/* {/* <!-- Post Item #1  --> */} 
        <div className="col-sm-12 col-md-12 col-lg-12">
        {/* <!-- ========================
      page title 
  =========================== --> */}
  <section className="page-title page-title-layout5">
    <div className="bg-img"><img src="assets/images/backgrounds/6.jpg" alt="background"/></div>
    <div className="container">
      <div className="row">
        <div className="col-12 d-flex justify-content-between flex-wrap align-items-center">
          <h1 className="pagetitle__heading my-3">This Page is Under Construction</h1>
          
        </div>{/* <!-- /.col-12 --> */}
      </div>{/* <!-- /.row --> */}
    </div>{/* <!-- /.container --> */}
  </section>{/* <!-- /.page-title --> */}

  {/* <!-- ======================
      FAQ
  ========================= --> */}
  
  <Helmet>
  <script src="/assets/js/jquery-3.5.1.min.js"></script>
<script src="/assets/js/plugins.js"></script>
<script src="/assets/js/main.js"></script>
  <script src=
"https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js" 
  type="text/javascript" />
    <link rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"/>
<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.3/css/all.css"/>

<link href="/assets/images/logo/logo-light-small.png" rel="icon"/>
  </Helmet>
        </div>{/* {/* <!-- /.col-lg-4  --> */} 
        </div>
);
};

export default UnderConstruction;
